// extracted by mini-css-extract-plugin
export default {"modalOverlay":"loading_modalOverlay__A7mNi","loader":"loading_loader__vCmrH","layers1":"loading_layers1__ViCRU","layer-tr":"loading_layer-tr__Ky9h+"};